import { render, staticRenderFns } from "./avoimet-asiat-yek-card.vue?vue&type=template&id=73452480&scoped=true&"
import script from "./avoimet-asiat-yek-card.vue?vue&type=script&lang=ts&"
export * from "./avoimet-asiat-yek-card.vue?vue&type=script&lang=ts&"
import style0 from "./avoimet-asiat-yek-card.vue?vue&type=style&index=0&id=73452480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73452480",
  null
  
)

export default component.exports